import React from 'react';
import Eevent from '../Event/Eevent';
import './Day.scss';
import {Link} from "react-router-dom";
import {Badge} from "@mui/material";
import {Lock} from "@mui/icons-material";

const day = (props ) =>  {
    let events = "";
    if (props.items.length > 0) {
        events = props.items.map(eevent => {
            return (
                <Link className={"single-event"} to={'/my-events/' + eevent.id} key={eevent.id}>
                    <Badge badgeContent={eevent.isPrivate ? <Lock sx={{ fontSize: 10 }} /> : null} color={"warning"} sx={{ width: '100%', '& .MuiBadge-badge': { top: 16, minWidth: 20, height: 20, borderRadius: '50%' } }}>
                        <Eevent data={eevent} />
                    </Badge>
                </Link>
            )
        });
    }

    return (
        <div className={"day" + (props.current ? " current" : "")}>
            <div className={"day-events"}>
                { events }
                <Link to={'/my-events/new/' + props.dayKey}>
                    <div className={"add-event"}></div>
                </Link>
            </div>
        </div>
    );
}

export default day;
